import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
  selector: 'layout-index',
  templateUrl: './layout-index.html',
  styleUrl: './layout-index.css',
  standalone: true,
  imports: [
    RouterOutlet
  ]
})
export default class LayoutIndex{

  scrollToSection(sectionId: string) {
    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}